module.exports = __webpack_public_path__ + "static/img/celoscope-8.304a932.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-8.jpg
// module id = KWVc
// module chunks = 51